import React from "react";
import ReactDOM from "react-dom/client";
import { extensions } from "./surebase/portal/libraries/util/Extensions";
import { Main } from "./surebase/portal/components/onsite/Main";
import "react-toastify/dist/ReactToastify.css";
// initialize timezone data
// noinspection ES6UnusedImports
import {} from "@js-joda/timezone";
import {LicenseInfo} from "@mui/x-license-pro";

const muiLicenseKey = "b61efcac5afd4b81e6238df548d101dfTz0xMzAwMzMsRT0xODEyNzU4Mzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MSxBVD1tdWx0aSxLVj0y";
LicenseInfo.setLicenseKey(muiLicenseKey);

// initialize extensions
// eslint-disable-next-line @typescript-eslint/no-unused-vars
extensions.load();

const container = document.createElement("div");
container.id = "root";

document.body.appendChild(container);
ReactDOM.createRoot(container).render(<Main />);
